// import { createApp } from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// import ElementPlus from 'element-plus';
// import 'element-plus/theme-chalk/index.css';
// // import 'dayjs/locale/zh-cn'
// import locale from 'element-plus/lib/locale/lang/zh-cn'
//
//
// const app = createApp(App)
//     .use(store)
//     .use(router)
//     .use(ElementPlus, {size: 'small' })
//     .mount('#app')


import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import '@/assets/css/global.css'

// ElementPlus.Dialog.props.closeOnClickModal.default = false;
createApp(App).use(store).use(router).use(ElementPlus, {
    locale: zhCn,
}).mount('#app')

// Object.keys(ElIconModules).forEach(key => {
//     createApp(App).component(key, ElIconModules[key])
// }
